import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerDevice } from '../lib/webauthn';
import { useAuth } from '../contexts/AuthContext';
import Footer from '../components/Footer';

export default function RegisterDevicePage() {
  const navigate = useNavigate();
  const { user, setSession } = useAuth();

  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const isBootstrap = !user;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { token, user: u } = await registerDevice({
        nickname: nickname.trim() || undefined,
        bootstrapEmail: isBootstrap ? email.trim().toLowerCase() : undefined,
      });
      setSession(token, u);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Erro ao registrar dispositivo');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
      <div className="card w-full max-w-sm space-y-4">
        <h1 className="text-2xl font-bold text-brand-600 text-center">Registrar dispositivo</h1>
        <p className="text-sm text-slate-600 text-center">
          {isBootstrap
            ? 'Primeiro acesso? Informe seu email admin e use a biometria pra criar a passkey.'
            : 'Adicione mais um dispositivo (ex: iPhone, outro Mac).'}
        </p>

        <form onSubmit={handleSubmit} className="space-y-3">
          {isBootstrap && (
            <div>
              <label className="block text-sm mb-1">Email admin</label>
              <input
                type="email"
                className="input"
                placeholder="lsouza2@outlook.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
          )}

          <div>
            <label className="block text-sm mb-1">Apelido do dispositivo</label>
            <input
              className="input"
              placeholder="MacBook Pro, iPhone, etc"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              maxLength={120}
            />
          </div>

          {error && <div className="bg-red-50 text-red-700 text-sm rounded p-3 break-words">{error}</div>}

          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? 'Aguardando biometria…' : 'Registrar com biometria'}
          </button>

          {isBootstrap && (
            <a href="/login" className="block text-xs text-slate-500 underline text-center">
              Já registrou? Voltar pro login
            </a>
          )}
        </form>
      </div>
      </div>
      <Footer />
    </div>
  );
}
